var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EmailLoader',[_c('p',[_vm._v(" We are proud to include you to our team! ")]),_c('div',{staticClass:"text-center"},[_c('b-button',{attrs:{"variant":"primary"}},[_vm._v(" Visit Dashboard ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }